import env, { AppMode } from './env';

export default {
  apps: {
    pos: {
      android:
        'https://play.google.com/store/apps/details?id=com.goodfynd.pos&hl=en_US',
      ios: 'https://apps.apple.com/us/app/goodfynd-point-of-sale-pos/id1530494533',
    },
  },
  mode: {
    isTesting: env.MODE === AppMode.TESTING,
    isDevelopment:
      env.NAME.toLowerCase() === 'development' ||
      env.NAME.toLowerCase() === 'local',
    isProduction: env.NAME.toLowerCase() === 'production',
    isStaging: env.NAME.toLowerCase() === 'staging',
  },
  settings: {
    countryCode: 'US',
    currencyCode: 'USD',
    locale: 'en-US',
    localeShort: 'en',
    ordering: {
      defaultMaxOfflineAmount: 50,
      step: {
        key: {
          1: 'Submitted',
          2: 'Preparing',
          3: 'Ready',
          4: 'Complete',
          91: 'Cancelled',
          93: 'Refunded',
          95: 'Abandoned',
          123: 'InProgress',
        },
        description: {
          1: 'Order has been submitted.',
          2: 'Order is being prepared.',
          3: 'Order is ready for :method.', // pickup vs. delivery
          4: 'Order has been picked up', // 'Order has been :method.', // picked up vs. delivered
          91: 'Order has been cancelled.',
          93: 'Order has been refunded.',
          95: 'Order has been abandoned.',
          123: 'Order is in progress.',
        },
        name: {
          submitted: 'Submitted',
          prepared: 'Preparing',
          ready: 'Ready',
          complete: 'Complete',
          canceled: 'Cancelled',
          refunded: 'Refunded',
          abandone: 'Abandoned',
          inProgress: 'In Progress',
        },
        options: ['Submitted', 'Preparing', 'Ready', 'Complete'],
        shortDescription: {
          1: 'Submitted',
          2: 'Being prepared',
          3: 'Ready for :method3.', // pickup vs. delivery
          4: ':method4', // ':method.', // picked up vs. delivered
          91: 'Cancelled.',
          93: 'Refunded.',
          95: 'Abandoned.',
          123: 'In progress.',
        },
        values: {
          abandoned: 95,
          canceled: 91,
          complete: 4,
          inProgress: 123,
          preparing: 2,
          ready: 3,
          refunded: 93,
          submitted: 1,
        },
      },
      tipOptions: [
        {
          label: '10%',
          value: 0.1,
        },
        {
          label: '20%',
          value: 0.2,
          default: true,
        },
        {
          label: '25%',
          value: 0.25,
        },
        {
          label: '30%',
          value: 0.3,
        },
        {
          label: 'Other',
          value: 0,
        },
      ],
    },
    search: {
      rowsPerPageOptions: [
        // {
        //   label: 3,
        //   value: 3,
        // },
        {
          label: 6,
          value: 6,
        },
        {
          label: 12,
          value: 12,
        },
        {
          label: 24,
          value: 24,
        },
        {
          label: 48,
          value: 48,
        },
        {
          label: 96,
          value: 96,
        },
      ],
    },
  },
};
